export var APPOINTMENT_TYPES;
(function (APPOINTMENT_TYPES) {
  APPOINTMENT_TYPES["INITIAL"] = "INITIAL";
  APPOINTMENT_TYPES["HOME_INSTALL"] = "HOME_INSTALL";
  APPOINTMENT_TYPES["SERVICE"] = "SERVICE";
})(APPOINTMENT_TYPES || (APPOINTMENT_TYPES = {}));